export default __webpack_public_path__ + "static/media/logo-alianca-no-text.00e73313.svg";